import { CenteredSpinner } from "../CenteredSpinner/CenteredSpinner";

export function LoadingPage() {
  return (
    <main>
      <CenteredSpinner />
    </main>
  );
}
